/* eslint-disable react/require-default-props,react/destructuring-assignment,react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withTranslation } from 'react-i18next';
import { FontAwesome } from '../../components/FontAwesome';
import { priceFormat } from '../../utilities/utilities';
import { PortalQualificationPropType } from '../../../CustomPropTypes/PortalPropTypes';
import { PortalButton } from '../PortalButton/PortalButton';
import { PortalCourseGroup } from '../PortalCourse/PortalCourseGroup';
import { LoadableResponsiveImage as ResponsiveImage } from '../../components/ResponsiveImage/LoadableResponsiveImage';
import { defaultStrings } from '../PortalShared';
import './PortalQualification.scss';

class _PortalQualification extends React.Component {
  static displayName = 'PortalQualification';

  static propTypes = {
    qualification: PortalQualificationPropType.isRequired,
    showCourses: PropTypes.bool.isRequired,
    excludeCoursePath: PropTypes.string,
    onCtaButtonClicked: PropTypes.func,
    onEnrolInCourse: PropTypes.func,
    defaultStrings: ImmutablePropTypes.map,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = { defaultStrings };

  static contextTypes = {
    strings: ImmutablePropTypes.map,
  };

  onFindOutMoreClicked = (event) => {
    const { onCtaButtonClicked } = this.props;
    if (event.target && onCtaButtonClicked) {
      onCtaButtonClicked(event.target.textContent);
    }
  };

  render() {
    const {
      qualification,
      showCourses,
      excludeCoursePath,
      onEnrolInCourse,
      onCtaButtonClicked,
      t,
    } = this.props;
    let courses = qualification
      .get('coreCourses')
      .concat(qualification.get('electiveCourses'));
    if (excludeCoursePath) {
      courses = courses.filter(
        (course) => course.get('path') !== excludeCoursePath
      );
    }
    const showElectiveCourses =
      qualification.get('electiveCourses').size > 0 &&
      qualification.get('requiredElectives') > 0;

    const price = priceFormat(
      qualification.get('price'),
      qualification.get('currency')
    );

    let priceString = t('free');
    if (qualification.get('price')) {
      priceString = qualification.get('isFreeToLearn')
        ? t('free_to_learn_price_to_certify', { price })
        : `${price}`;
    }

    const title = qualification.get('title');

    return (
      <portal-qualification>
        <div className="portal-qualification-wrapper portal-color-primary row collapse">
          <div className="portal-qualification-inner">
            <ResponsiveImage
              src={qualification.get('imageUrl')}
              responsive
              background
              backgroundClassName="portal-qualification-img"
              onResize="up"
              resizeWidthOnly
            />
            <div className="portal-qualification-summary-wrapper clearfix">
              <div className="portal-qualification-description">
                <div>{qualification.get('code')}</div>
                <h3>{title}</h3>
                <div className="version">
                  {qualification.get('version', '')}
                </div>
                <div>{qualification.get('introduction')}</div>
              </div>
              <div className="portal-qualification-features">
                <ul>
                  {qualification.get('certifiedBy') ? (
                    <li>
                      <FontAwesome name="graduation-cap" />
                      {t('certified_by')}
                      <br />
                      {qualification.get('certifiedBy')}
                    </li>
                  ) : null}
                  <li>
                    <FontAwesome name="tag" />
                    {priceString.split('\n').map((line, lineIndex) => (
                      <div key={`line_${lineIndex}`}>{line}</div>
                    ))}
                  </li>
                  {qualification.get('studyMode') ? (
                    <li>
                      <FontAwesome name="globe" />
                      {qualification.get('studyMode')}
                    </li>
                  ) : null}
                  <li>
                    <FontAwesome name="map" />
                    {showElectiveCourses
                      ? t('core_course_with_count', {
                          count: qualification.get('coreCourses').size,
                        })
                      : t('course_with_count', {
                          count: qualification.get('coreCourses').size,
                        })}
                    {showElectiveCourses && <br />}
                    {showElectiveCourses &&
                      t('elective_with_count', {
                        count: qualification.get('requiredElectives'),
                      })}
                  </li>
                </ul>
                <PortalButton>
                  <a
                    href={qualification.get('url')}
                    onClick={this.onFindOutMoreClicked}
                  >
                    {t('find_out_more')}
                  </a>
                </PortalButton>
              </div>
            </div>
          </div>
        </div>
        {showCourses && courses.size > 0 ? (
          <PortalCourseGroup
            {...{ courses, onEnrolInCourse, onCtaButtonClicked }}
            title={t('other_courses_in_this_qualification')}
          />
        ) : null}
      </portal-qualification>
    );
  }
}

export const PortalQualification = withTranslation('landingPages')(
  _PortalQualification
);
